// src/Profil/Profil.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api";
import "./Profil.css";

import {
    TbUser,
    TbUsers,
    TbLock,
    TbFileDescription,
    TbCurrencyEuro,
    TbLink,
    TbFolderPlus,
    TbShieldLock,
} from "react-icons/tb";

export default function Profil() {
    const [jeAdmin, setJeAdmin] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });
    }, []);

    useEffect(() => {
        let active = true;

        (async () => {
            try {
                const res = await apiFetch("/api/auth/me");
                if (!res.ok || !active) return;

                const data = await res.json();
                if (!active) return;

                setJeAdmin(data?.isAdmin === true);
            } catch {
                // ignore
            }
        })();

        return () => {
            active = false;
        };
    }, []);

    return (
        <div className="pf">
            <ZadeveNavPanel jeAdmin={jeAdmin} />
        </div>
    );
}

function ZadeveNavPanel({ jeAdmin }) {
    const navigate = useNavigate();

    return (
        <section className="zadeve">
            <div className="zadeve__glava">
                <div className="zadeve__actions">
                    <button
                        className="btn-nav"
                        onClick={() =>
                            navigate("/profil/podatkiupnika", { replace: false })
                        }
                        title="Podatki o upniku"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbUser />
                        </span>
                        <span className="btn-nav__text">PODATKI O UPNIKU</span>
                    </button>

                    <button
                        className="btn-nav"
                        onClick={() =>
                            navigate("/profil/podatkidolznika", { replace: false })
                        }
                        title="Podatki o dolžniku"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbUsers />
                        </span>
                        <span className="btn-nav__text">PODATKI O DOLŽNIKU</span>
                    </button>

                    <button
                        className="btn-nav"
                        onClick={() =>
                            navigate("/profil/pobotnica", { replace: false })
                        }
                        title="Pobotnica"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbFileDescription />
                        </span>
                        <span className="btn-nav__text">POBOTNICA</span>
                    </button>

                    <button
                        className="btn-nav"
                        onClick={() =>
                            navigate("/profil/stroskovnik", { replace: false })
                        }
                        title="Stroškovnik"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbCurrencyEuro />
                        </span>
                        <span className="btn-nav__text">STROŠKOVNIK</span>
                    </button>

                    <button
                        className="btn-nav"
                        onClick={() => navigate("/profil/rubezi", { replace: false })}
                        title="Rubeži"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbLock />
                        </span>
                        <span className="btn-nav__text">RUBEŽI</span>
                    </button>

                    <button
                        type="button"
                        className="btn-nav btn-nav--info"
                        onClick={() =>
                            navigate("/profil/pregleddolznika", { replace: false })
                        }
                        title="Pregled dolžnika – povezave na registre"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbLink />
                        </span>
                        <span className="btn-nav__text">POVEZAVE</span>
                    </button>

                    <button
                        className="btn-nav btn-nav--primary"
                        onClick={() =>
                            navigate("/profil/novprimer", { replace: false })
                        }
                        title="Nov primer"
                    >
                        <span className="btn-nav__icon" aria-hidden="true">
                            <TbFolderPlus />
                        </span>
                        <span className="btn-nav__text">NOV PRIMER</span>
                    </button>

                    {jeAdmin && (
                        <button
                            className="btn-nav"
                            onClick={() =>
                                navigate("/profil/admin/uporabniki", { replace: false })
                            }
                            title="Administracija uporabnikov"
                        >
                            <span className="btn-nav__icon" aria-hidden="true">
                                <TbShieldLock />
                            </span>
                            <span className="btn-nav__text">UPORABNIKI</span>
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}